import http from "@/http/aisea/axios";
const resource = "/enterprises/crews/basic_conditions";

/**
 * 法人基本設定API
 */
export default {
  /**
   * 法人基本設定取得API
   */
  fetch() {
    return http.get(`${resource}`);
  },
};
